import PropTypes from "prop-types";
import React from "react";
import Styles from "./index.scss";

const SocialButtons = ({ url, text }) => {
    const encodedUrl = encodeURI(url);
    const encodedTitle = encodeURI(text);
    return (
        <ul className="main-item__social">
            <style jsx="true">{Styles}</style>
            <li>
                <a
                    href={`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`}
                    rel="nofollow"
                >
                    <i className="icon-logo-facebook" />
                </a>
            </li>
            <li>
                <a
                    href={`http://twitter.com/intent/tweet/?text=${encodedTitle}&url=${encodedUrl}`}
                    rel="nofollow"
                >
                    <i className="icon-logo-twitter" />
                </a>
            </li>
            <li>
                <a href={`https://plus.google.com/share?url=${encodedUrl}`} rel="nofollow">
                    <i className="icon-logo-googleplus" />
                </a>
            </li>
        </ul>
    );
};

SocialButtons.propTypes = {
    text: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
};

export default SocialButtons;
